// =========================================================
// * 우아한닷컴
// =========================================================

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import HtmlView from '@/components/base/htmlView'
import './plugins/cookie'
import './plugins/location'
import './plugins/base'
import './plugins/vee-validate'
// import './plugins/lodash'
import './plugins/moment'
import './plugins/local-storage'
import './plugins/session-storage'
import './plugins/message'
import './plugins/media-query'
import './plugins/gtag'
// import './plugins/vue-lottie-player'
import Alert from './plugins/Alert'
import i18n from './i18n'
import '@/sanitize'
import '@/filter'
// import '@/static/scss/index.scss'

Vue.use(Alert)
Vue.component('HtmlView', HtmlView)
Vue.config.productionTip = false

// console.log('VUE_APP_VERSION', process.env.VUE_APP_VERSION)

// const i18nVersion = process.env.VUE_APP_VERSION
// window.LOCALE_VERSION = {
//   en: {
//     global: i18nVersion,
//     company: i18nVersion,
//     main: i18nVersion,
//     service: i18nVersion,
//     writing: i18nVersion,
//     newsroom: i18nVersion,
//     fonts: i18nVersion,
//     music: i18nVersion,
//     consult: i18nVersion,
//     question: i18nVersion,
//     InformationCenter: i18nVersion,
//   },
//   ko: {
//     global: i18nVersion,
//     company: i18nVersion,
//     main: i18nVersion,
//     service: i18nVersion,
//     writing: i18nVersion,
//     newsroom: i18nVersion,
//     fonts: i18nVersion,
//     music: i18nVersion,
//     consult: i18nVersion,
//     question: i18nVersion,
//     InformationCenter: i18nVersion,
//   }
// }

const getApp = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

window.getApp = getApp
